// @ts-nocheck
import { injectable } from 'inversify'
import { ModalPresenter } from 'Components/Atoms'

@injectable()
export class RunbookPageModalsPresenter {
  public chooseRunbookStartTimeModalPresenter: ModalPresenter = new ModalPresenter()
}
